import * as TAG_ACTION from 'constant/action/tag'
import { handleActions } from 'redux-actions'

const initialState = {
  tags: {}
}

export default handleActions(
  {
    [TAG_ACTION.UPDATE_TAGS]: (state, action) => ({
      ...state,
      tags: action.payload
    })
  },
  initialState
)
